
import { useState, useEffect } from 'react';

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    const handleLoad = () => {
      setIsLoading(false);
    };

    window.addEventListener('load', handleLoad);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Dark overlay with blur */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Logo - Much bigger */}
        <div className="mb-8">
          <img 
            src="https://static.readdy.ai/image/fa730e8436814daa818c1c8fe5de2f74/fdcd0b712f787aca4097791e0d45e821.png" 
            alt="Arts et Confort Logo" 
            className="w-48 h-48 object-contain"
          />
        </div>
        
        {/* Loading animation */}
        <div className="flex space-x-2 mb-4">
          <div className="w-3 h-3 bg-red-600 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-red-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-red-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        
        {/* Loading text */}
        <p className="text-white text-lg font-medium">Chargement...</p>
      </div>
    </div>
  );
};

export default Preloader;
